import { scriptRowOptionsRequest } from './assistant/optionsAction';

/** Pure action model shared by visible and folded defect rows. */
export const warningOptionsRequestOf = (
  episode: number | undefined,
  violation: { gate: string; message: string; kind?: string; chipId?: string | null },
) => scriptRowOptionsRequest(episode, violation, violation.chipId ?? null);

export const softWarningKindCount = (violations: ReadonlyArray<{ gate: string }>): number => new Set(violations.map((v) => v.gate)).size;
